/**
 * jugeboxeSessionKeys
 * Centralized sessionStorage keys for JugeBoxe student sessions.
 */
const jugeboxeSessionKeys = {
  studentToken: 'jugeboxeStudentToken',
  classeId: 'jugeboxeStudentClasseId',
  authFlag: 'jugeboxe_auth',
};

export default jugeboxeSessionKeys;
